import { Component, OnInit } from '@angular/core';
import { ScheduleService,MasterService,HrmsService } from '../../services/index';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-timetable',
  templateUrl: './timetable.component.html',
  styleUrls: ['./timetable.component.scss'],
  providers:[ScheduleService,MasterService]
})
export class TimetableComponent implements OnInit {
  closeResult: string;
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;

  selclid: number = 0;
    mascls: any = [];
    massub: any = [];
    massec: any = [];

    arremp: any = [];
    arrcourse:any=[];
    objfilt:any={};
    objsch:any={};
    arrtimetable:any=[];
  
   data = [
     {
       id: 1,
       name: 'Usa'
     },
     {
       id: 2,
       name: 'England'
     }
  ];

  constructor(private http: HttpClient,private hservice:HrmsService, private sservice: ScheduleService,private mservice:MasterService,private modalService: NgbModal) { }
  open(content) {
    this.modalOptions = {
     
      size:'md'
     
    }
    this.modalService.open(content, this.modalOptions ).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
 
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }



  ngOnInit(): void {
    this.objfilt.daynm='MONDAY';
    this.mascourse();
    // this.Getclasslist();
    // this.getsection();
    // this.Getsel_sp_massubjects();
    // this.getstaff();
    // this.getschtimetable();
  }

  mascourse() {
    this.mservice.mascourse()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrcourse = resultArray;
            this.objfilt.crid=resultArray[0].crid;
           
             this.Getclasslist();
            // this.corclass();
        },
        error => console.log("Error :: " + error)
        )
  }

  exportrecord(){
    var clcd=localStorage.getItem('clcd');
    var aycd=localStorage.getItem('aycd');
    // if(txt=="")
    // {

    // }
     //var url=this.liservice.callurl+"export/expstudent.php?clcd="+clcd+"&aycd="+aycd+"&oprtype="+oprtype+"&clid="+this.defclass+"&crid="+this.defcorse;
     var url=this.sservice.callurl+"export/exptimetable.php?clcd="+clcd+"&aycd="+aycd+"&clid="+this.objfilt.clid+"&scid="+this.objfilt.scid+"&crid="+this.objfilt.crid
  
     window.open(url,'','');
   }

  getstaff() {
    this.hservice.getemployes()
        .subscribe(
        resultArray => {
            console.log('getlibdepartment', resultArray);
           
          var activeemps   = resultArray.emplst.filter(function(arr)
            {
        
              return arr.emstatus=='Active';
            });
            this.arremp= activeemps.map( o => { return { emid: o.emid, emnm: o.emnm} });
           
            
        },
        error => console.log("Error :: " + error)
        )
  }

  selstaffbyclass()
  {
    this.hservice.selstaffbyclass(this.objfilt.clid,this.objfilt.crid,this.objfilt.scid)
    .subscribe(
    resultArray => {
        console.log('getlibdepartment', resultArray);
       
     
        this.arremp= resultArray;
       
        
    },
    error => console.log("Error :: " + error)
    )

  }
  Getclasslist() {
    this.mservice.masclass()
        .subscribe(
        resultArray => {
            console.log('class-result', resultArray);
            this.mascls = resultArray;
            this.objfilt.clid=resultArray[0].clid;
            this.getsection();
        },
        error => console.log("Error :: " + error)
        )
}

onclasschange()
{
 
  this.SelectClsSubDetails();
  this.selstaffbyclass();
  this.getschtimetable();
}

Getsel_sp_massubjects() {
  this.mservice.sel_sp_massubjects()
      .subscribe(
      resultArray => {
          
          this.massub = resultArray;
         
      },
      error => console.log("Error :: " + error))
}

SelectClsSubDetails() {
  debugger
  //var clid = this.clid;
  let clcd=localStorage.getItem('clcd');
  let aycd=localStorage.getItem('aycd');
  var clssubdata = { clid:this.objfilt.clid,clcd:clcd,aycd:aycd,crid:this.objfilt.crid };
  console.log('model', clssubdata);
  this.mservice.masclasssubject(clssubdata)
      .subscribe(resultArray => {
          console.log('classsubs', resultArray);
          this.massub = resultArray;
          this.objfilt.suid=resultArray[0].suid;
         // this.getevpattern("selco",resultArray[0].suid);
          //alert (resultArray.message);

      }, error =>
          alert('error in connection')
      );
  //this.closeAddExpenseModal.nativeElement.click();
}



getsection() {
  var defsec={scid:'0',scnm:'ALL'};
  this.mservice.massection()
      .subscribe(
      resultArray => {
          console.log('class-result', resultArray);
          this.massec = resultArray;
          this.objfilt.scid=resultArray[0].scid;
          this.onclasschange();
         // this.massec.splice(0,0,defsec);
          //this.objsch.secid='0';
      },
      error => console.log("Error :: " + error)
      )
}


getschtimetable() {
  var defsec={scid:'0',scnm:'ALL'};
  this.sservice.getschtimetable(this.objfilt.clid,this.objfilt.scid,this.objfilt.daynm,this.objfilt.crid)
      .subscribe(
      resultArray => {
          console.log('class-result', resultArray);
          this.arrtimetable = resultArray;
          
         // this.massec.splice(0,0,defsec);
          //this.objsch.secid='0';
      },
      error => console.log("Error :: " + error)
      )
}

addtt(item){
  debugger
  
  if(item.emid=='0' || item.subid=='0')
  {
    alert ('Please select staff/subject ');
  }
  else{
var ob1=this.objfilt;
ob1.oprtype='insert';
  console.log(item);
  this.sservice.saveschtimetable(ob1,item)
  .subscribe(
  resultArray => {
      console.log('class-result', resultArray);
      alert (resultArray.message);
      this.getschtimetable();
     // this.massec.splice(0,0,defsec);
      //this.objsch.secid='0';
  },
  error => console.log("Error :: " + error)
  )
}

}


modtt(item){
 if(confirm('Are you sure you want to modify')) 
 {
  var ob1=this.objfilt;
  ob1.oprtype='update';
    console.log(item);
    this.sservice.saveschtimetable(ob1,item)
    .subscribe(
    resultArray => {
        console.log('class-result', resultArray);
        alert (resultArray.message);
        this.getschtimetable();
       // this.massec.splice(0,0,defsec);
        //this.objsch.secid='0';
    },
    error => console.log("Error :: " + error)
    )
  }
  
  }


  removett(item){
    if(confirm('Are you sure you want to delete')) 
    {
     var ob1=this.objfilt;
     ob1.oprtype='delete';
       console.log(item);
       this.sservice.saveschtimetable(ob1,item)
       .subscribe(
       resultArray => {
           console.log('class-result', resultArray);
           alert (resultArray.message);
           this.getschtimetable();
          // this.massec.splice(0,0,defsec);
           //this.objsch.secid='0';
       },
       error => console.log("Error :: " + error)
       )
     }
     
     }
}
